import { lazy, Suspense } from 'react';

import { RobinLogoSkeleton } from '@/shared/ui/robin-logo-skeleton';

const RobinJrHome = lazy(() => import('./Page').then((module) => ({ default: module.Page })));

export const PageLazy = () => {
  return (
    <Suspense fallback={<RobinLogoSkeleton position="center" />}>
      <RobinJrHome />
    </Suspense>
  );
};
